module.exports = __webpack_public_path__ + "static/media/ProximaNovaAlt-Bold.8b646d45.ttf";